const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">About RangDesaaj</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A warm welcome message and a brief introduction to RangDesaaj.
          </p>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p className="text-gray-600 mb-4">
                The story behind RangDesaaj, including its founding, mission, and vision. We are passionate about
                creating unique resin art pieces that bring joy and beauty to your life.
              </p>
              <p className="text-gray-600">
                Our journey began with a simple love for art and creativity. Today, we specialize in custom resin
                creations that reflect your personal style and vision.
              </p>
            </div>
            <div className="bg-gray-200 rounded-lg aspect-square flex items-center justify-center">
              <svg className="w-24 h-24 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Our Impact</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-black mb-2">500+</div>
              <p className="text-gray-600">Custom Orders Fulfilled</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-black mb-2">98%</div>
              <p className="text-gray-600">Customer Satisfaction Rate</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-black mb-2">3</div>
              <p className="text-gray-600">Years in Business</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-black mb-2">50+</div>
              <p className="text-gray-600">Unique Designs Created</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About
